"use strict";

exports.__esModule = true;
exports.default = void 0;

function isIOS() {
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) // iPad on iOS 13 detection
  || navigator.userAgent.includes("Mac") && navigator.maxTouchPoints > 1;
}

const isAndroid = () => /(android)/i.test(navigator.userAgent);

const isIE = () => /(msie)/i.test(navigator.userAgent) || /(trident)/i.test(navigator.userAgent);

const browser = {
  isIOS,
  isAndroid,
  isIE
};
var _default = browser;
exports.default = _default;